export function chatListScopesEqual(a, b) {
    if (a.kind !== b.kind)
        return false;
    switch (a.kind) {
        case "community":
            return b.kind === "community" && b.id.communityId === a.id.communityId;
        default:
            return true;
    }
}
